<!--White background header -->

<div class="white-bkg" *ngIf="white == true && mobile == false">
  <div class="container">
    <div class="logo">
      <img
        src="./assets/img/degesco-logo.png"
        alt="Man"
        class="img-fluid"
      />
    </div>
    <div class="page-title">
      <h1>{{headerText}}</h1>
    </div>
  </div>
</div>

<!--White background user header mobile -->

<div class="m_white-user-bkg" *ngIf="white == true && mobile == true">
  <div class="user-header" *ngIf="btnLogOut">
    <div class="user">
      <div class="user-img">
      </div>
      <div class="user-name" *ngIf="btnLogOut">
        <p>{{username}}</p>
        <h6>{{email}}</h6>
      </div>
    </div>
    <button type="button" class="btn">
      <img src="./assets/icon/logout-black.svg" alt="Icona" (click)="logout()"/>
    </button>
  </div>
  <div class="page-title">
    <h1>{{headerText}}</h1>
  </div>
</div>

<!--blue background header -->
<div class="blue-bkg" *ngIf="blue == true && mobile == false">
  <div class="container">
    <div class="logo">
      <img
        src="./assets/img/degesco-logo_white.png"
        alt="Man"
        class="img-fluid"
      />
    </div>
    <div class="page-title" *ngIf="headerText != ''">
      <h1>{{headerText}}</h1>
    </div>
    <div class="user" *ngIf="btnLogOut">
      <div class="user-name">
        <p>{{username}}</p>
        <h6>{{email}}</h6>
      </div>
      <button type="button" class="btn">
        <img src="./assets/icon/logout.svg" alt="Icona" (click)="logout()" />
      </button>
    </div>
  </div>
</div>
